import view from './view.html';

/* @ngInject */
export default function (AuthService) {
	return {
		scope:    true,
		replace:  true,
		template: view,
		link:     (scope, element) => {
			scope.user        = AuthService.getUser();
			scope.AuthService = AuthService;

			if (scope.user.workable.latestIdBadge) {
				scope.photoUrl = `${process.env.API_ENDPOINT}photos/${scope.user.workable.latestIdBadge.id}/download?token=${AuthService.getToken()}`;
			} else {
				scope.photoUrl = `https://www.gravatar.com/avatar/${scope.user.workable.emailHash}?d=mm`;
			}

			element.metisMenu();
		},
	};
};


// WEBPACK FOOTER //
// ./src/js/directives/sidebar/staff/index.js